import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import { Col, Input, Label, Row } from "reactstrap";
import DropdownAsyncUsers from "components/Common/DropdownAsyncUsers";
import { COLOR_EMPLOYMENT_TYPE, COLOR_PRIORITY_JOB_POST, LIST_OPTION_EMPLOYMENT_TYPE, LIST_OPTION_GENDER, LIST_OPTION_PRIORITY_JOB_POST } from "helpers/constans";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import DropdownOptionNew from "components/Common/DropdownOptionNew";

export interface Props {
  id?: any;
  formik: any;
  listCheckedUsers?: any;
  setListCheckedUsers?: any;
  dataStoreUser?: any;
  setDataStoreUser?: any;
  typeNumberOfRecruits?: any;
  setTypeNumberOfRecruits?: any;
  formatJobCategories?: any;
}

registerLocale("en", en);
registerLocale("ko", ko);

const BasicInformation = ({
  id = "",
  formik,
  listCheckedUsers,
  setListCheckedUsers,
  dataStoreUser,
  setDataStoreUser,
  typeNumberOfRecruits,
  setTypeNumberOfRecruits,
  formatJobCategories
}: Props) => {
  const { t } = useTranslation();

  const handleSelectAsyncUsers = (event: any) => {
    formik.setFieldValue("userId", event?.value);
    setDataStoreUser && setDataStoreUser(event?.data?.store);

    if (event?.data?.store) {
      formik.setFieldValue("storeId", event?.data?.store?.id);
      formik.setFieldValue("storeAttachments", event?.data?.store?.imageUrls);
      formik.setFieldValue(
        "contactPhone",
        event?.data?.store?.managerPhoneNumber
      );
      formik.setFieldValue("contactEmail", event?.data?.store?.managerEmail);
      formik.setFieldValue("storeDescription", event?.data?.store?.description);
    }
    setListCheckedUsers && setListCheckedUsers(event);
  };

  return (
    <React.Fragment>
      <div
        className="d-flex flex-column mb-4 pt-3 pb-1 px-3 position-relative"
        style={{
          border: "1px dashed var(--vz-primary)",
          borderRadius: "4px",
        }}
      >
        <span
          className="text-primary position-absolute fs-13 px-1"
          style={{
            backgroundColor: "var(--vz-secondary-bg)",
            top: "0px",
            transform: "translateY(-50%)",
          }}
        >
          {t("Basic Information")}
        </span>
        <div className="d-flex flex-column flex-lg-row gap-3 gap-lg-4">
          <Row>
            <Col md={6} lg={6}>
              <div className="mb-3">
                <Label className="form-label">
                  {t("Owner Post")} <span className="text-danger">*</span>
                </Label>

                <DropdownAsyncUsers
                  name="manual-push-users"
                  onChangeSelect={handleSelectAsyncUsers}
                  isMulti={false}
                  placeholder={`${t("Select Owner Post")}...`}
                  listCheckedUsers={listCheckedUsers}
                  isShowOnManualPush={true}
                  isAllOption={false}
                  defaultParams={{
                    type: "MANAGER",
                  }}
                  key={`list-users`}
                  // isDisabled={id ? true : false}
                />

                {formik.touched.userId && formik.errors.userId ? (
                  <div className="text-danger mt-2">{formik.errors.userId}</div>
                ) : null}
              </div>
            </Col>

            <Col md={6} lg={6}></Col>

            {(listCheckedUsers ||
              (listCheckedUsers && formik?.values?.storeId)) && (
              <>
                {dataStoreUser ? (
                  <div className=""></div>
                ) : (
                  <p className="text-danger">
                    {t("Please set up Store Info to create job postings")}
                  </p>
                )}
              </>
            )}

            <Col md={12} lg={12}>
              <div className="mb-3">
                <Label htmlFor="title" className="form-label">
                  {t("Job Title")} <span className="text-danger">*</span>
                </Label>
                <Input
                  name="title"
                  type="text"
                  className="form-control"
                  id="title"
                  placeholder={t("Job Title")}
                  value={formik?.values?.title}
                  onChange={(event: any) =>
                    formik.setFieldValue("title", event?.target?.value)
                  }
                />
                {formik.touched.title && formik.errors.title ? (
                  <div className="text-danger mt-2">{formik.errors.title}</div>
                ) : null}
              </div>
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <Label htmlFor="titleKoreaInput" className="form-label">
                  {t("Gender")} <span className="text-danger">*</span>
                </Label>

                <div className="d-flex justify-content-start align-items-center">
                  {LIST_OPTION_GENDER?.map((item, index) => {
                    return (
                      <div
                        className="d-flex justify-content-start align-items-center form-check me-3"
                        key={index}
                        onClick={() => {
                          formik.setFieldValue("gender", item?.value);
                        }}
                      >
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name="gender"
                          id={item?.value}
                          value={item?.value}
                          checked={item?.value === formik?.values?.gender}
                          style={{ minWidth: "16px" }}
                          onChange={(event) => {
                            formik.setFieldValue("gender", item?.value);
                          }}
                        />
                        <label
                          className="form-check-label position-relative"
                          htmlFor={item?.value}
                        >
                          {t(item?.label)}
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Col>

            <Col md={6} lg={6}>
              <div className="mb-3">
                <Label htmlFor="headCount" className="form-label">
                  {t("Number of recruits")}
                </Label>

                <div className="d-flex justify-content-start align-items-center">
                  <div
                    className="d-flex justify-content-start align-items-center form-check me-3"
                    onClick={() => setTypeNumberOfRecruits(1)}
                  >
                    <input
                      className="form-check-input me-2"
                      type="radio"
                      name="number-of-recruits"
                      id={`number-of-recruits-1`}
                      checked={typeNumberOfRecruits > 0}
                      style={{ minWidth: "16px" }}
                      onChange={(event) => {
                        setTypeNumberOfRecruits(1);
                      }}
                    />
                    <label
                      className="form-check-label position-relative"
                      htmlFor={`number-of-recruits-1`}
                    >
                      {t("Specific Number")}
                    </label>
                  </div>
                  <div
                    className="d-flex justify-content-start align-items-center form-check me-3"
                    onClick={() => setTypeNumberOfRecruits(0)}
                  >
                    <input
                      className="form-check-input me-2"
                      type="radio"
                      name="number-of-recruits"
                      id={`number-of-recruits-0`}
                      checked={typeNumberOfRecruits === 0}
                      style={{ minWidth: "16px" }}
                      onChange={(event) => {
                        setTypeNumberOfRecruits(0);
                        formik.setFieldValue("headCount", 0);
                      }}
                    />
                    <label
                      className="form-check-label position-relative"
                      htmlFor={`number-of-recruits-0`}
                    >
                      {t("Ongoing Recruitment")}
                    </label>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={6} lg={6}></Col>

            {typeNumberOfRecruits > 0 && (
              <>
                <Col md={4} lg={4}>
                  <div className="mb-3">
                    <Input
                      name="headCount"
                      type="number"
                      className="form-control"
                      id="headCount"
                      placeholder={t("Number of recruits")}
                      value={formik?.values?.headCount || undefined}
                      onChange={(event: any) => {
                        formik.setFieldValue("headCount", event?.target?.value);
                      }}
                    />
                    {formik.touched.headCount && formik.errors.headCount ? (
                      <div className="text-danger mt-2">
                        {formik.errors.headCount}
                      </div>
                    ) : null}
                  </div>
                </Col>
                <Col md={6} lg={6}></Col>
              </>
            )}

            <Col md={4} lg={4}>
              <div className="mb-3">
                <Label htmlFor="employmentType" className="form-label">
                  {t("Employment Type")} <span className="text-danger">*</span>
                </Label>
                <DropdownStatusNew
                  name="employmentType"
                  dataList={LIST_OPTION_EMPLOYMENT_TYPE || []}
                  placeholder={`${t("Employment Type")}...`}
                  className="dropdown-status-rounded"
                  classNamePrefix="name-prefix"
                  initialValue={formik?.values?.employmentType}
                  onChangeSelect={(e: any) => {
                    formik.setFieldValue("employmentType", e?.value);
                  }}
                  isHasOptionAll={false}
                  colors={COLOR_EMPLOYMENT_TYPE}
                />
                {formik.touched.employmentType &&
                formik.errors.employmentType ? (
                  <div className="text-danger mt-2">
                    {formik.errors.employmentType}
                  </div>
                ) : null}
              </div>
            </Col>

            <Col md={4} lg={4}>
              <div className="mb-3">
                <Label htmlFor="priorityRecruitment" className="form-label">
                  {t("Priority")} <span className="text-danger">*</span>
                </Label>
                <DropdownStatusNew
                  name="priorityRecruitment"
                  dataList={LIST_OPTION_PRIORITY_JOB_POST || []}
                  placeholder={`${t("Priority")}...`}
                  className="dropdown-status-rounded"
                  classNamePrefix="name-prefix"
                  initialValue={formik?.values?.priorityRecruitment}
                  onChangeSelect={(e: any) => {
                    formik.setFieldValue("priorityRecruitment", e?.value);
                  }}
                  isHasOptionAll={false}
                  colors={COLOR_PRIORITY_JOB_POST}
                />
                {formik.touched.priorityRecruitment &&
                formik.errors.priorityRecruitment ? (
                  <div className="text-danger mt-2">
                    {formik.errors.priorityRecruitment}
                  </div>
                ) : null}
              </div>
            </Col>

            <Col md={12} lg={12}>
              <div className="mb-3">
                <Label className="form-label">
                  {t("Field of recruitment")}
                </Label>

                <DropdownOptionNew
                  name="jobCategoryId"
                  dataList={formatJobCategories || []}
                  placeholder={`${t("Field of recruitment")}...`}
                  className="dropdown-status-rounded"
                  classNamePrefix="name-prefix"
                  initialValue={formik?.values?.jobCategoryId}
                  onChangeSelect={(event: any) => {
                    formik.setFieldValue("jobCategoryId", event?.value);
                    formik.setFieldValue("jobCategoryText", event?.label);
                  }}
                  isHasOptionAll={false}
                  isClearable={true}
                />

                {formik.touched.planId && formik.errors.planId ? (
                  <div className="text-danger mt-2">{formik.errors.planId}</div>
                ) : null}
              </div>
            </Col>

          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BasicInformation;
